import type { Resources } from './en';

const es: Resources = {
  nav: {
    songs: 'Canciones',
    artists: 'Artistas',
    search: 'Buscar',
    generator: 'Generador',
    signIn: 'Iniciar sesión',
    signUp: 'Registrarse',
    signOut: 'Cerrar sesión',
  },
  home: {
    heroTitle: 'Descubre las historias que hay detrás de tus letras de canciones favoritas',
    heroSubtitle: 'Analizamos el significado de las letras de tus canciones favoritas',
    searchPlaceholder: 'Busca cualquier canción y significado…',
    trendingLabel: 'TENDENCIAS',
    latestLabel: 'ÚLTIMO',
    allArtists: 'Todos los artistas',
  },
  search: {
    title: 'Resultados',
    empty: 'No se encontraron canciones.',
    placeholder: 'Busca cualquier canción y significado…',
  },
  songCard: {
    by: 'por',
  },
  footer: {
    updates: 'Actualizaciones',
    about: 'Acerca de',
    contact: 'Contacto',
    help: 'Centro de ayuda ↗',
    terms: 'Términos y Condiciones',
    privacy: 'Privacidad y Cookies',
    copyright: '© {{years}}',
    language: 'Idioma',
  },
  languages: {
    en: 'Inglés',
    es: 'Español',
    pt: 'Portugués',
  },
  songDetail: {
    pageSubtitle: 'Letra, significado y referencia para crear una canción original con MixGenie.',
    moreByArtist: 'Más de {{artist}}',
    meaningHeading: 'Significado',
    lyricsHeading: 'Letra',
    lyricsOriginalTab: 'Original',
    lyricsAlreadyIn: 'Esta letra ya está en {{language}}.',
    noTranslationYet: 'Aún no hay traducción al {{language}}.',
    noMeaningYet: 'Aún no hay significado en {{language}}.',
    getNow: 'Obtener ahora',
    translatingTo: 'Traduciendo al {{language}}…',
    generatingMeaning: 'Generando significado en {{language}}…',
    noLyricsForMeaning: 'No encontramos la letra, así que no pudimos generar el significado.',
    noLyricsFound: 'No se encontró la letra de esta canción.',
    translationUnavailable: 'Traducción no disponible sin letra.',
    songNotFound: 'Canción no encontrada',
    loadingSong: 'Cargando canción…',
    fetchingLyrics: 'Buscando letra…',
    generatingMeaningShort: 'Generando significado…',
    findingCoverArt: 'Buscando portada…',
    almostReady: 'Casi listo…',
  },
  createSimilar: {
    heading: 'Crea una canción parecida a esta',
    description: 'Regístrate gratis en MixGenie con {{credits}} créditos y genera una canción original inspirada en {{title}} de {{artist}}.',
    descriptionAuthed: 'Genera una canción original inspirada en {{title}} de {{artist}}.',
    cta: 'Empezar con esta referencia',
    ctaAuthed: 'Empezar con esta referencia',
  },
  streamingLinks: {
    heading: 'Escuchar en',
  },
};

export default es;
